<template>
  <div class="aside-box" :class="{ asideHide: !isShowAsidePopup }">
    <button class="close" @click="closePopup"></button>
    <div class="iframe-box">
      <iframe
        :src="userHref"
        class="user-center"
        @load="iframeOnload"
        ref="userFrame"
      ></iframe>
    </div>
    <button
      class="hideCopyBtn"
      ref="copyBtn"
      type="button"
      v-clipboard:copy="mgCode"
      v-clipboard:success="onCopySucc"
      v-clipboard:error="onCopyError"
    ></button>
  </div>
</template>

<script type="text/javascript">
import { mapGetters, mapActions } from 'vuex';
import h5Sdk, {
  ACCOUNT_TYPE,
  SAVE_LOGIN_TYPE_LOCALSTORAGE,
  UUID
} from '../mixins/h5Sdk.js';
import globalConfig from '../utiles/globalConfig';
import { isFn, judgeIsSameMainHost } from '../utiles/index';
import { HREF_IS_DMM } from '../store/web/h5';

export default {
  data() {
    return {
      twitterCallback: '',
      mgCode: '',
      unLoginAsideOnLoad: false,
      loginAsideOnLoad: false,
      asidePopupV: new Date().valueOf() || '',
      openTargetName: this.openTarget,
      bindGiftState: ''
    };
  },
  props: ['isShowAsidePopup', 'openTarget'],
  watch: {
    openTarget(newValue) {
      this.openTargetName = newValue;
    },
    isShowAsidePopup(newValue) {
      if (!newValue) {
        this.callPassportFn('gotoPassportHome');
      }
    }
  },
  computed: {
    userHref() {
      const accountName = HREF_IS_DMM
        ? localStorage.getItem('currLoginAccount') || this.accountName
        : this.accountName;
      const curHref = window.location.href;
      // 如果链接存在着两个参数就是DMM，没有这两个参数就不是DMM，这两个参数是什么值不清楚，存在这两个参数就是DMM
      const isDmm =
        curHref.indexOf('transaction_id=') !== -1 &&
        curHref.indexOf('h=') !== -1
          ? '1'
          : '0';
      let link = `https://jpabres.37games.com/html/passport.html?apps=&country=JP&devicePlate=${
        window.isPhone ? 'wap' : 'pc'
      }&gameId=${
        this.gameId
      }&hideSDKLogo=1&gpid=${globalConfig.getLclStorageItem(
        UUID
      )}&if_back=1&portrait=1&roleId=${
        this.roleId
      }&roleName=${encodeURIComponent(this.roleName)}&serverId=${
        this.serverId
      }&loginName=${encodeURIComponent(accountName)}&userName=${
        this.accountId
      }&zone=${
        this.lang
      }&h5=1&web=1&loginId=${this.getLoginId()}&isDmm=${isDmm}#/${
        this.isShowAsidePopup ? this.openTargetName : ''
      }`;
      return window.globalGetGotoLink({ link });
    },
    ...mapGetters([
      'letter',
      'gameId',
      'isLogin',
      'lang',
      'serverId',
      'roleName',
      'roleId',
      'accountName',
      'accountId'
    ])
  },
  mixins: [h5Sdk],
  mounted() {
    // 接收用户中心的传来的消息
    globalConfig.addEvenListener(this.sdkListenerFn);
  },
  beforeUnmount() {
    // 弹窗销毁，移除监听
    globalConfig.removeEventListener(this.sdkListenerFn);
  },
  methods: {
    // 接收用户中心传来的消息进行方法调用
    sdkListenerFn(e) {
      const evt = e || event;
      const data = evt.data;
      console.log(evt, data);
      if (judgeIsSameMainHost(evt.origin, window.location.origin)) {
        if (data.method && isFn(this[data.method])) {
          try {
            this[data.method](data.params);
          } catch (e) {
            console.log(e);
          }
        }
      }
    },
    // 调用用户中心的方法
    callPassportFn(method, params) {
      this.$refs.userFrame.contentWindow.postMessage(
        {
          method,
          params
        },
        '*'
      );
    },
    closePopup() {
      this.$emit('closeAsidePopup');
    },
    formateAjaxRes(res) {
      if (res.result) {
        return {
          result: parseInt(res.result, 10),
          msg: res.msg,
          data: {
            bind_info: [
              {
                bind_type: ACCOUNT_TYPE.fb,
                bind_status: res.data.IS_BIND_FB || 0,
                nick_name: res.data.FB_NAME || ''
              },
              {
                bind_type: ACCOUNT_TYPE.tw,
                bind_status: res.data.IS_BIND_TW || 0,
                nick_name: res.data.TW_NAME || ''
              },
              {
                bind_type: ACCOUNT_TYPE.gc,
                bind_status: res.data.IS_BIND_GC || 0,
                nick_name: res.data.GC_NAME || ''
              },
              {
                bind_type: ACCOUNT_TYPE.gp,
                bind_status: res.data.IS_BIND_GP || 0,
                nick_name: res.data.GP_NAME || ''
              }
            ]
          }
        };
      } else {
        return {
          result: parseInt(res.res.result, 10),
          msg: parseInt(res.res.result, 10) ? res.res.msg : res.errmsg,
          data: {
            bind_info: [
              {
                bind_type: ACCOUNT_TYPE.fb,
                bind_status: res.data.IS_BIND_FB || 0,
                nick_name: res.data.FB_NAME || ''
              },
              {
                bind_type: ACCOUNT_TYPE.tw,
                bind_status: res.data.IS_BIND_TW || 0,
                nick_name: res.data.TW_NAME || ''
              },
              {
                bind_type: ACCOUNT_TYPE.gc,
                bind_status: res.data.IS_BIND_GC || 0,
                nick_name: res.data.GC_NAME || ''
              },
              {
                bind_type: ACCOUNT_TYPE.gp,
                bind_status: res.data.IS_BIND_GP || 0,
                nick_name: res.data.GP_NAME || ''
              }
            ]
          }
        };
      }
    },
    bindInit(params) {
      this.getUserBindInfo().then((res) => {
        let realRes = this.formateAjaxRes(res);
        params.callback && this.callPassportFn(params.callback, realRes);
      });
    },
    debindAccount(params) {
      this.readyDebindAccount(params).then((res) => {
        // 若解绑的账号是当前登录的账号，就重新登回游客账号
        if (
          parseInt(res.result, 10) === 1 &&
          globalConfig.getLclStorageItem(SAVE_LOGIN_TYPE_LOCALSTORAGE) ===
            params.type
        ) {
          this.readyTouristLogin().then((res) => {
            if (parseInt(res.result, 10) === 1) {
              this.$emit('updataGamePage');
              globalConfig.setLclStorageItem(
                SAVE_LOGIN_TYPE_LOCALSTORAGE,
                ACCOUNT_TYPE.to
              );
            }
          });
        }
        let realRes = this.formateAjaxRes(res);
        params.callback && this.callPassportFn(params.callback, realRes);
      });
    },
    bindAccount(params) {
      this.readyBindAccount(params).then((res) => {
        if (res) {
          let realRes = this.formateAjaxRes(res);
          params.callback && this.callPassportFn(params.callback, realRes);
        }
      });
    },
    switchAccount(params) {
      this.readySwitchAccount(params).then((res) => {
        if (res) {
          if (parseInt(res.result, 10) === 1) {
            try {
              globalConfig.statistics('login_success', {
                login_type: params.type
              });
            } catch (e) {}
            this.$emit('updataGamePage');
            this.closePopup();
            this.reset_data();
            let realType = params.type;
            if (realType === 'mg') {
              realType = 'to';
            }
            globalConfig.setLclStorageItem(
              SAVE_LOGIN_TYPE_LOCALSTORAGE,
              ACCOUNT_TYPE[realType]
            );
          }
          let realRes = this.formateAjaxRes(res);
          params.callback && this.callPassportFn(params.callback, realRes);
          this.openTargetName = '';
          this.bindGiftState = '';
        }
      });
    },
    updateBindGiftState(params) {
      if (params.hasRole && params.canGet !== this.bindGiftState) {
        this.bindGiftState = params.canGet;
        // 因为侧边栏每次刷新页面都会发一次事件，所以这里过滤一下相同的值的事件
        document.querySelector('.j-gamepage-iframe').contentWindow.postMessage({
          action: 'updateBindGiftState',
          param: {
            canGet: params.canGet
          }
        });
      }
    },
    copyFollowerCode(params) {
      this.mgCode = params.code;
      this.$nextTick(() => {
        this.$refs.copyBtn.click();
      });
    },
    switchPC(params) {
      this.getFingerprint().then((uid) => {
        this.pcCodeLogin({ ...params, loginId: uid }).then((res) => {
          if (res.res.result == '1') {
            this.$emit('updataGamePage');
            this.closePopup();
            this.reset_data();
          }
          params.callback && this.callPassportFn(params.callback, res);
        });
      });
    },
    iframeOnload() {
      let self = this;
      if (!this.unLoginAsideOnLoad) {
        this.unLoginAsideOnLoad = true;
        this.$emit('asideLoaded');
        this.setUserCenterHref();
      }
      if (this.isLogin && !this.loginAsideOnLoad) {
        this.loginAsideOnLoad = true;
        this.setUserCenterHref();
      }
    },
    setUserCenterHref(href) {
      this.callPassportFn('historyPushState', this.userHref);
    },
    readyDebindAccount(params) {
      switch (params.type) {
        case ACCOUNT_TYPE.fb:
          return this.debindFbAccount();
        case ACCOUNT_TYPE.tw:
          return this.debindTwitterAccount();
        case ACCOUNT_TYPE.gp:
          return new Promise((resolve) => {
            resolve();
          });
        case ACCOUNT_TYPE.gc:
          return new Promise((resolve) => {
            resolve();
          });
        default:
          return new Promise((resolve) => {
            resolve();
          });
      }
    },
    readyBindAccount(params) {
      try {
        globalConfig.statistics('bind_type', {
          bind_type: params.type
        });
      } catch (e) {}
      switch (params.type) {
        case ACCOUNT_TYPE.fb:
          return this.readyBindFbAccount('bind');
        case ACCOUNT_TYPE.tw:
          this.twitterCallback = params.callback;
          globalConfig.addEvenListener(this.readyBindTwi);
          // window.addEventListener('message', this.readyBindTwi, false)
          return this.readyTwitterLogin('bind');
        case ACCOUNT_TYPE.gp:
          return new Promise((resolve) => {
            resolve();
          });
        case ACCOUNT_TYPE.gc:
          return new Promise((resolve) => {
            resolve();
          });
        default:
          return new Promise((resolve) => {
            resolve();
          });
      }
    },
    readySwitchAccount(params) {
      try {
        globalConfig.statistics('login_type', {
          login_type: params.type
        });
      } catch (e) {}
      switch (params.type) {
        case ACCOUNT_TYPE.fb:
          return this.readyFbLogin('switch');
        case ACCOUNT_TYPE.tw:
          this.twitterCallback = params.callback;
          globalConfig.addEvenListener(this.readySwitchTwi);
          return this.readyTwitterLogin('switch');
        case ACCOUNT_TYPE.gp:
          return new Promise((resolve) => {
            resolve();
          });
        case ACCOUNT_TYPE.gc:
          return new Promise((resolve) => {
            resolve();
          });
        case ACCOUNT_TYPE.mg:
          return this.getFingerprint().then((res) => {
            return this.readySwitchMigrateCode(res, params);
          });
        default:
          return new Promise((resolve) => {
            resolve();
          });
      }
    },
    onCopySucc() {
      alert('コピー成功');
    },
    onCopyError() {
      alert('コピー失敗');
    },
    ...mapActions([
      'getUserBindInfo',
      'debindFbAccount',
      'debindTwitterAccount',
      'reset_data',
      'pcCodeLogin'
    ])
  }
};
</script>
